export const WorkQueueStatus = {
  OPEN: 'open',
  READ: 'read',
  SENT: 'send',
  DONE: 'done',
  ERROR: 'error'
};

export default WorkQueueStatus;
